// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28YOr","placeholdersHeader":"styles_placeholdersHeader__1nKG_","editorStyle":"styles_editorStyle__1815H","placeholdersBox":"styles_placeholdersBox__389FG"};